import 'css-chunksrc/client/pages/documentsPage/reportsPage/filterForm/dateFilter/styles.scss';export default {
  "resourcesFilter": "_resourcesFilter_e2rdu_1",
  "input": "_input_e2rdu_7",
  "toggleArrow": "_toggleArrow_e2rdu_23",
  "selectedResourcesNames": "_selectedResourcesNames_e2rdu_31",
  "name": "_name_e2rdu_40",
  "placeholder": "_placeholder_e2rdu_49",
  "list": "_list_e2rdu_56",
  "item": "_item_e2rdu_70",
  "opened": "_opened_e2rdu_78"
};